import api from '@/apis/di/budgetGroupItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

//Combo grid Nhóm mục chi
export const useBudgetGroupItemComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onGroupItemComboboxLoadData = (payload, row, column) => {
    if (payload.columns && !payload.columns.includes('rep_budget_item_code')) {
      payload.columns += ',rep_budget_item_code';
    }

    payload.sort = 'budget_group_item_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const groupItemComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã nhóm',
        dataField: 'budget_group_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên nhóm',
        dataField: 'budget_group_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_group_item_code',
    valueField: 'budget_group_item_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onGroupItemComboboxLoadData,
  };

  return {
    groupItemComboConfig,
    onGroupItemComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
